import axios from 'axios';
import { baseURL } from '../utils/axios';
//const studentToken = localStorage.getItem("studentToken");

//upload avatar
export const handleImage = async (image, id, token) => {
  const formData = new FormData();
  formData.append('student', id);
  formData.append('avatar', image);

  const response = await axios.post(
    `${baseURL}/student/upload-avatar`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

//UPLOAD SCHOOL LOGO
export const handleLogoImage = async (image, id, token) => {
  const formData = new FormData();
  formData.append('logo', image);
  const response = await axios.post(
    `${baseURL}/schools/${id}/logo/upload`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

//UPLOAD SCHOOL Banner
export const handleBannerUpload = async (image, id, token) => {
  const formData = new FormData();
  formData.append('banner', image);
  const response = await axios.post(
    `${baseURL}/schools/${id}/banner/upload`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

//UPLOAD TEASER VIDEO
export const handlerTeaserUpload = async (
  video,
  id,
  courseId,
  onUploadProgress
) => {
  const token = localStorage.getItem('token');
  const formData = new FormData();
  formData.append('teaser', video);

  const bar = document.getElementById('progress-bar');

  const response = await axios.post(
    `${baseURL}/schools/${id}/courses/${courseId}/teaser`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
      onUploadProgress,
    }
  );

  return response.data;
};

//UPLOAD COURSE BANNER VIDEO
export const handlerCourseBannerUpload = async (
  image,
  id,
  courseId,
  onUploadProgress
) => {
  const token = localStorage.getItem('token');
  const formData = new FormData();
  formData.append('banner', image);

  const bar = document.getElementById('progress-bar');

  const response = await axios.post(
    `${baseURL}/schools/${id}/courses/${courseId}/banner`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
      onUploadProgress,
    }
  );

  return response.data;
};

//UPLOAD CONTENT
export const handleContentUpload = async (
  sn,
  title,
  duration,
  type,
  is_activity,
  video,
  layout,
  schoolId,
  courseId,
  topicId,
  lessonId,
  description,
  onUploadProgress
) => {
  const token = localStorage.getItem('token');
  const formData = new FormData();
  formData.append('sn', sn);
  formData.append('title', title);
  formData.append('duration', duration);
  formData.append('type', type);
  formData.append('is_activity', is_activity);
  if (video) {
    formData.append('file', video);
  }

  if (type === 'image' || type === 'text-image') {
    formData.append('layout', layout);
  }

  if (type === 'text' || type === 'text-image') {
    formData.append('description', description);
  }

  const response = await axios.post(
    `${baseURL}/schools/${schoolId}/courses/${courseId}/topics/${topicId}/lessons/${lessonId}/contents`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
      onUploadProgress,
    }
  );

  return response.data;
};

//UPLOAD CONTENT
export const updateContentUpload = async (
  sn,
  title,
  duration,
  type,
  is_activity,
  video,
  layout,
  schoolId,
  courseId,
  topicId,
  lessonId,
  description,
  onUploadProgress,
  contentId
) => {
  const token = localStorage.getItem('token');
  const formData = new FormData();
  formData.append('sn', sn);
  formData.append('title', title);
  formData.append('duration', duration);
  formData.append('type', type);
  formData.append('is_activity', is_activity);
  if (video) {
    formData.append('file', video);
  }

  if (type === 'image' || type === 'text-image') {
    formData.append('layout', layout);
  }

  if (type === 'text' || type === 'text-image') {
    formData.append('description', description);
  }

  const response = await axios.post(
    `${baseURL}/schools/${schoolId}/courses/${courseId}/topics/${topicId}/lessons/${lessonId}/contents/${contentId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
      onUploadProgress,
    }
  );

  return response.data;
};

//POST QUIZ
export const saveQuizContent = async (
  sn,
  title,
  duration,
  type,
  is_activity,
  questions,
  schoolId,
  courseId,
  topicId,
  lessonId
) => {
  const token = localStorage.getItem('token');

  let formData = {
    sn,
    title,
    duration,
    type,
    is_activity,
    questions,
  };

  const response = await axios.post(
    `${baseURL}/schools/${schoolId}/courses/${courseId}/topics/${topicId}/lessons/${lessonId}/contents`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};
